<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
  >
    <path
      d="M76.6797 84.4351H85.199V92.9553H76.6797V84.4351Z"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M85.199 72.5126V76.0605H76.6797V67.5403H81.65"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M67.7127 73.721L65.1517 75.2389L65.8068 72.3361L63.5708 70.371L66.5337 70.0982L67.7127 67.3608L68.8888 70.0982L71.8547 70.371L69.6167 72.3361L70.2718 75.2389L67.7127 73.721Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M55.4271 73.721L52.8671 75.2389L53.5211 72.3361L51.2852 70.371L54.249 70.0982L55.4271 67.3608L56.6042 70.0982L59.568 70.371L57.3321 72.3361L57.9871 75.2389L55.4271 73.721Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M43.1409 73.721L40.5819 75.2389L41.236 72.3361L39 70.371L41.9639 70.0982L43.1409 67.3608L44.318 70.0982L47.2838 70.371L45.0469 72.3361L45.701 75.2389L43.1409 73.721Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M31.1409 73.721L28.5819 75.2389L29.236 72.3361L27 70.371L29.9639 70.0982L31.1409 67.3608L32.318 70.0982L35.2838 70.371L33.0469 72.3361L33.701 75.2389L31.1409 73.721Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.1409 73.721L16.5819 75.2389L17.236 72.3361L15 70.371L17.9639 70.0982L19.1409 67.3608L20.318 70.0982L23.2838 70.371L21.0469 72.3361L21.701 75.2389L19.1409 73.721Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M55.4271 90.7952L52.8671 92.3121L53.5211 89.4103L51.2852 87.4452L54.249 87.1724L55.4271 84.4351L56.6042 87.1724L59.568 87.4452L57.3321 89.4103L57.9871 92.3121L55.4271 90.7952Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M43.1409 90.7952L40.5819 92.3121L41.236 89.4103L39 87.4452L41.9639 87.1724L43.1409 84.4351L44.318 87.1724L47.2838 87.4452L45.0469 89.4103L45.701 92.3121L43.1409 90.7952Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M31.1409 90.7952L28.5819 92.3121L29.236 89.4103L27 87.4452L29.9639 87.1724L31.1409 84.4351L32.318 87.1724L35.2838 87.4452L33.0469 89.4103L33.701 92.3121L31.1409 90.7952Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.1409 90.7952L16.5819 92.3121L17.236 89.4103L15 87.4452L17.9639 87.1724L19.1409 84.4351L20.318 87.1724L23.2838 87.4452L21.0469 89.4103L21.701 92.3121L19.1409 90.7952Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M78.8091 71.0971L80.9396 73.2247L85.909 67.5403"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M55.6572 53.3694H43.6924L44.44 47.3875H54.9096L55.6572 53.3694Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M58.2409 56.3608H41.1088C40.9544 56.3627 40.802 56.3259 40.6655 56.2538C40.5289 56.1817 40.4126 56.0766 40.327 55.9481C40.2415 55.8195 40.1894 55.6716 40.1756 55.5178C40.1618 55.3641 40.1866 55.2092 40.2479 55.0675C40.4915 54.5589 40.874 54.1296 41.3512 53.8291C41.8284 53.5286 42.3809 53.3692 42.9448 53.3694H56.4049C56.9688 53.3692 57.5213 53.5286 57.9985 53.8291C58.4757 54.1296 58.8582 54.5589 59.1018 55.0675C59.1631 55.2092 59.1879 55.3641 59.1741 55.5178C59.1603 55.6716 59.1083 55.8195 59.0227 55.9481C58.9371 56.0766 58.8208 56.1817 58.6843 56.2538C58.5477 56.3259 58.3953 56.3627 58.2409 56.3608Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M70.3376 47.3874C71.4014 47.3872 72.4216 46.9644 73.1738 46.212C73.926 45.4597 74.3485 44.4394 74.3485 43.3755V41.4055H25V43.3755C25 43.9025 25.1038 44.4242 25.3055 44.911C25.5072 45.3978 25.8028 45.8402 26.1754 46.2127C26.5481 46.5853 26.9904 46.8808 27.4773 47.0823C27.9642 47.2839 28.486 47.3875 29.0129 47.3874H70.3376Z"
      fill="#211F58"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M74.3485 14.0129C74.3485 12.9486 73.9257 11.9279 73.1731 11.1754C72.4206 10.4228 71.3999 10 70.3356 10H29.0119C27.9478 10.0003 26.9273 10.4232 26.175 11.1757C25.4226 11.9282 25 12.9488 25 14.0129V41.4057H74.3485V14.0129Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M49.6753 43.4248C49.483 43.4246 49.2949 43.4815 49.1349 43.5882C48.9749 43.6949 48.8502 43.8466 48.7764 44.0243C48.7027 44.2019 48.6833 44.3974 48.7207 44.5861C48.7581 44.7747 48.8506 44.948 48.9865 45.0841C49.1225 45.2202 49.2957 45.3128 49.4843 45.3504C49.6729 45.388 49.8685 45.3688 50.0462 45.2953C50.2239 45.2217 50.3758 45.0971 50.4826 44.9372C50.5895 44.7773 50.6465 44.5893 50.6465 44.397C50.6467 44.2694 50.6216 44.143 50.5729 44.025C50.5241 43.9071 50.4526 43.7999 50.3624 43.7096C50.2722 43.6193 50.1651 43.5477 50.0472 43.4988C49.9293 43.45 49.803 43.4248 49.6753 43.4248Z"
      fill="white"
    />
    <path
      d="M39.6133 18.0069V25.3254C39.6417 27.7441 40.4129 30.0956 41.8224 32.0613C43.2319 34.0271 45.2116 35.512 47.4933 36.3151L48.5669 36.7091C49.2845 36.9731 50.0725 36.9731 50.7901 36.7091L51.8637 36.3151C54.1454 35.512 56.1251 34.0271 57.5346 32.0613C58.9441 30.0956 59.7153 27.7441 59.7437 25.3254V18.0069C59.7426 17.7194 59.6572 17.4387 59.498 17.1993C59.3389 16.96 59.113 16.7726 58.8484 16.6604C52.971 14.2727 46.3939 14.2727 40.5165 16.6604C40.2504 16.7714 40.0229 16.9582 39.8622 17.1977C39.7016 17.4371 39.615 17.7186 39.6133 18.0069Z"
      fill="#D9EDE2"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M47.6262 26.2937L45.5035 24.1711C45.424 24.0914 45.3294 24.0282 45.2254 23.9851C45.1214 23.9419 45.0099 23.9197 44.8973 23.9197C44.7847 23.9197 44.6732 23.9419 44.5691 23.9851C44.4651 24.0282 44.3706 24.0914 44.291 24.1711L43.3809 25.0802C43.2201 25.2412 43.1299 25.4595 43.1299 25.687C43.1299 25.9145 43.2201 26.1327 43.3809 26.2937L47.3209 30.2337C47.4005 30.3134 47.495 30.3766 47.599 30.4197C47.703 30.4628 47.8145 30.485 47.9271 30.485C48.0397 30.485 48.1513 30.4628 48.2553 30.4197C48.3593 30.3766 48.4538 30.3134 48.5334 30.2337L55.9672 22.7999C56.1279 22.6389 56.2182 22.4207 56.2182 22.1932C56.2182 21.9657 56.1279 21.7474 55.9672 21.5864L55.058 20.6773C54.897 20.5165 54.6788 20.4263 54.4513 20.4263C54.2238 20.4263 54.0056 20.5165 53.8445 20.6773L48.23 26.2918C48.15 26.3717 48.0416 26.4168 47.9285 26.4172C47.8154 26.4175 47.7067 26.3732 47.6262 26.2937Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
